import { Timeslot } from "types";
import create from "zustand";

export interface RosterDrawerStore {
    isOpen: boolean;
    timeslotId: ID | null;
    timeslot: Timeslot | null;
    setOpen: () => void;
    setClose: () => void;
    setTimeslot: (timeslot: Timeslot | null) => void;
}

export const useRosterDrawerStore = create<RosterDrawerStore>((set) => ({
    isOpen: false,
    timeslotId: null,
    timeslot: null,
    setOpen: () => set(() => ({ isOpen: true })),
    setClose: () => set(() => ({ isOpen: false, timeslotId: null, timeslot: null })),
    setTimeslot: (timeslot: Timeslot | null) => set(() => ({ timeslot, timeslotId: timeslot ? timeslot.id : null })),
}));
